import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { IMessage, MessageType } from '../../models/message';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  animations: [
    trigger('remove', [
      state('false', style({
        height: '*'
      })),
      state('true', style({
        height: '0'
      })),
      transition('* => true', [
        style({ height: '*' }),
        animate(250, style({ height: 0 }))
      ])
    ])
  ]
})
export class MessageComponent implements OnInit {

  /**
   * message property
   *
   * @type {Message}
   * @memberof MessageComponent
   */
  @Input() message: IMessage;

  /**
   * Auto-dismiss timeout in milliseconds
   *
   * @type {number}
   * @memberof MessageComponent
   */
  @Input() timeout = 0;

  /**
   * dismiss event
   *
   * @type {EventEmitter<any>}
   * @memberof MessageComponent
   */
  @Output() dismiss: EventEmitter<any> = new EventEmitter();

  messageType: string;

  /**
   * object of classes to apply on the message element
   *
   * @type {{}}
   * @memberof MessageComponent
   */
  currentClasses: {};

  remove = false;

  /**
   * Id of running timeout
   *
   * @type {number}
   * @memberof MessageComponent
   */
  timeoutId: number;

  get classes(): string {
    return 'alert alert-' + this.messageType + ' alert-dismissible';
  }

  constructor() {
  }

  ngOnInit() {
    this.initType();

    // add timeout
    if (this.timeout > 0) {
      this.timeoutId = window.setTimeout(() => { this.remove = true; }, this.timeout);
    }

  }

  /**
   * raise the dismiss event
   *
   * @memberof MessageComponent
   */
  onDismissClicked() {
    this.remove = true;
  }

  onRemoveDone() {
    if (this.remove) {
      this.dismiss.emit(this.message.id);
    }
  }

  /**
   * initialize alert types
   *
   * @private
   * @memberof MessageComponent
   */
  private initType() {
    switch (this.message.type) {
      case MessageType.Success:
        this.messageType = 'success';
        break;
      case MessageType.Information:
        this.messageType = 'info';
        break;
      case MessageType.Waning:
        this.messageType = 'warning';
        break;
      case MessageType.Error:
        this.messageType = 'danger';
        break;
      case MessageType.Debug:
        this.messageType = 'dark';
        break;

    }
  }

}
